import classnames from 'classnames/bind';
import { FC, memo, ReactNode } from 'react';
import styles from './ControlArea.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  /** Already-translated count text (e.g. 「1,234件」) — feature code owns i18n. */
  count: ReactNode;
  /** The layout switch (or any other control) placed on the right. */
  children?: ReactNode;
  testId?: string;
};

/**
 * Generic left-count / right-control row shown above a table/card section.
 * Shared across sections that offer a table/card layout toggle (e.g. 支払明細,
 * 仕訳) — feature code supplies the translated count text and the control.
 */
export const ControlArea: FC<Props> = memo(({ count, children, testId }) => {
  return (
    <div className={cx('container')} data-testid={testId}>
      <span className={cx('count')}>{count}</span>
      {children}
    </div>
  );
});
ControlArea.displayName = 'ControlArea';
